import '@hotwired/turbo-rails'
import { configure } from '@37signals/lexxy'

// Configure Lexxy presets — must happen before editor elements register
configure({
  email: {
    attachments: false,
    markdown: false,
    toolbar: {
      upload: false
    }
  }
})
import posthog from 'posthog-js'

// PostHog analytics initialization
const posthogApiKey = document.querySelector('meta[name="posthog-api-key"]')?.content
if (posthogApiKey) {
  posthog.init(posthogApiKey, {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'always',
    session_recording: {
      recordCrossOriginIframes: true
    }
  })
  window.posthog = posthog
}
import { StreamActions } from "@hotwired/turbo"
import * as Turbo from "@hotwired/turbo"
import "flowbite/dist/flowbite.turbo.js"
import '../controllers'

// Custom Turbo Stream action to close slideovers
StreamActions.close_slideover = function() {
  const slideoverId = this.getAttribute("slideover-id")
  if (slideoverId) {
    document.dispatchEvent(new CustomEvent('slideover:close', { detail: { id: slideoverId } }))
  }
}

// Custom Turbo Stream action to redirect (used when a resource is deleted by another user)
StreamActions.redirect = function() {
  const url = this.getAttribute("url")
  if (url) {
    Turbo.visit(url, { action: "replace" })
  }
}

// Active Storage Direct Uploads
import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// Custom confirmation modal
import { setupConfirmationModal } from "../custom/confirmation_modal.js";
setupConfirmationModal(Turbo);

// We need to override the default rendering function for Turbo Frames in the turbo:before-frame-render event handler with a custom one that utilizes View Transitions.
// https://code.avi.nyc/turbo-view-transitions-in-rails
// https://turbo.hotwired.dev/handbook/frames#custom-rendering
// https://dev.to/nejremeslnici/how-to-use-view-transitions-in-hotwire-turbo-1kdi
addEventListener("turbo:before-frame-render", (event) => {
  if (document.startViewTransition) {
    const originalRender = event.detail.render
    event.detail.render = (currentElement, newElement) => {
      document.startViewTransition(()=> originalRender(currentElement, newElement))
    }
  }
})